import { Elements } from '@stripe/react-stripe-js';
import { Appearance, loadStripe } from '@stripe/stripe-js';
import CompletePage from './CompletionPage';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const SuccessPage = () => {
  const clientSecret = new URLSearchParams(window.location.search).get(
    'payment_intent_client_secret',
  );

  const appearance: Appearance = {
    theme: 'night',
    variables: {
      colorPrimary: '#0570de',
      colorBackground: '#151525',
      borderRadius: '12px',
    },
  };

  return (
    <Elements
      options={{
        clientSecret: clientSecret || '',
        appearance,
      }}
      stripe={stripePromise}
    >
      <CompletePage clientSecret={clientSecret} />
    </Elements>
  );
};

export default SuccessPage;
